(function () {
  'use strict';

  if (window.PGCompleteSetV3) return;
  window.PGCompleteSetV3 = true;

  var CONFIG = window.PGCompleteSetConfig || {};
  var SETTINGS = Object.assign({ discountRate: 0.30, discountActive: false }, window.PGCompleteSetSettings || {});
  var productCache = {};
  var busy = false;
  var refreshTimer = null;
  var observer = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  async function requestJson(url, options) {
    options = options || {};
    var fetchOptions = Object.assign({}, options, {
      credentials: 'same-origin',
      headers: Object.assign({
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      }, options.headers || {})
    });
    var response = await fetch(url, fetchOptions);

    var data = await response.json().catch(function () { return {}; });
    if (!response.ok) {
      throw new Error(data.description || data.message || 'The cart could not be updated.');
    }
    return data;
  }

  function getCart() {
    return requestJson(root() + 'cart.js', { cache: 'no-store' });
  }

  function getProduct(handle) {
    if (productCache[handle]) return productCache[handle];
    productCache[handle] = requestJson(root() + 'products/' + encodeURIComponent(handle) + '.js', { cache: 'no-store' })
      .catch(function (error) {
        delete productCache[handle];
        throw error;
      });
    return productCache[handle];
  }

  function createElement(tag, className, text) {
    var element = document.createElement(tag);
    if (className) element.className = className;
    if (text != null) element.textContent = text;
    return element;
  }

  function property(item, key) {
    return item && item.properties && item.properties[key] != null ? String(item.properties[key]) : '';
  }

  function cleanProperties(properties) {
    var result = {};
    Object.entries(properties || {}).forEach(function (entry) {
      if (entry[1] != null) result[entry[0]] = String(entry[1]);
    });
    return result;
  }

  function newArtworkGroup() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return 'pg-' + Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  function eligible(item, config) {
    if (!config.eligibleSourceVariantIds || !config.eligibleSourceVariantIds.length) return true;
    return config.eligibleSourceVariantIds.map(String).includes(String(item.variant_id));
  }

  function targetAlreadyInCart(cart, offer) {
    return (cart.items || []).some(function (item) {
      return String(item.product_id) === String(offer.targetProductId);
    });
  }

  function getContext(cart) {
    var items = cart.items || [];
    for (var index = 0; index < items.length; index += 1) {
      var source = items[index];
      var config = CONFIG[String(source.product_id)];
      if (!config || !eligible(source, config)) continue;
      var uk = String((window.PGRewardV101 && window.PGRewardV101.country) || (window.PG_MARKET_CONFIG && window.PG_MARKET_CONFIG.country) || '').toUpperCase() === 'GB';
      var offers = config.offers.filter(function (offer) {
        return !(uk && offer.type === 'digital_download') && !targetAlreadyInCart(cart, offer);
      });
      if (offers.length) return { source: source, config: config, offers: offers };
    }
    return null;
  }

  function availableVariants(product, offer) {
    return (product.variants || []).filter(function (variant) {
      if (variant.available === false) return false;
      if (offer.fixedVariantId && String(variant.id) !== String(offer.fixedVariantId)) return false;
      if (offer.petCount && String(variant.option1) !== String(offer.petCount)) return false;
      return true;
    });
  }

  function productImage(product, variant) {
    if (variant && variant.featured_image && variant.featured_image.src) return variant.featured_image.src;
    if (typeof product.featured_image === 'string') return product.featured_image;
    if (product.featured_image && product.featured_image.src) return product.featured_image.src;
    return (product.images && product.images[0]) || '';
  }

  function optionLabel(variant, offer) {
    var parts = String(variant.title || '').split(' / ').map(function (part) { return part.trim(); });
    if (offer.type === 'cushion') return parts[parts.length - 1] || variant.title;
    if (offer.type === 'phone_case') {
      return parts.find(function (part) { return /iphone|galaxy/i.test(part); }) || variant.title;
    }
    return variant.title || 'Default';
  }

  function money(cents, currency) {
    try {
      return new Intl.NumberFormat(document.documentElement.lang || 'en-GB', {
        style: 'currency',
        currency: currency || (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'GBP'
      }).format(Number(cents || 0) / 100);
    } catch (error) {
      return '£' + (Number(cents || 0) / 100).toFixed(2);
    }
  }

  function offerPrice(cents) {
    return Math.round(Number(cents || 0) * (1 - SETTINGS.discountRate));
  }

  function buildPrice(variant, cart) {
    var price = createElement('div', 'pg-complete-set__price');
    price.append(
      createElement('span', 'pg-complete-set__price-original', money(variant.price, cart.currency)),
      createElement('strong', 'pg-complete-set__price-offer', money(offerPrice(variant.price), cart.currency))
    );
    return price;
  }

  function buildCard(context, data, cart, surface) {
    var offer = data.offer;
    var product = data.product;
    var variants = data.variants;
    var firstVariant = variants[0];
    var card = createElement('article', 'pg-complete-set__card pg-complete-set__card--' + offer.type);
    card.dataset.pgCompleteSetCard = offer.type;

    var image = createElement('img', 'pg-complete-set__image');
    image.src = productImage(product, firstVariant);
    image.alt = offer.title;
    image.loading = 'lazy';

    var content = createElement('div', 'pg-complete-set__card-content');
    var titleRow = createElement('div', 'pg-complete-set__title-row');
    titleRow.append(
      createElement('h4', 'pg-complete-set__card-title', offer.title),
      createElement('span', 'pg-complete-set__badge', '30% off')
    );

    content.append(
      titleRow,
      createElement('p', 'pg-complete-set__card-note', 'Uses the same approved artwork'),
      buildPrice(firstVariant, cart)
    );

    var select = null;
    if (variants.length > 1) {
      var field = createElement('label', 'pg-complete-set__field');
      field.append(createElement('span', 'pg-complete-set__field-label', offer.selectorLabel || 'Choose an option'));
      select = createElement('select', 'pg-complete-set__select');

      variants.forEach(function (variant) {
        var option = createElement('option', '', optionLabel(variant, offer));
        option.value = variant.id;
        option.dataset.price = variant.price;
        select.append(option);
      });

      field.append(select);
      content.append(field);
    }

    var button = createElement('button', 'pg-complete-set__button', offer.buttonLabel || 'Add');
    button.type = 'button';
    Object.assign(button.dataset, {
      pgCompleteSetAdd: '',
      surface: surface,
      offerType: offer.type,
      sourceLine: context.source.key || '',
      sourceProductId: context.config.sourceProductId,
      sourceVariantId: context.source.variant_id,
      targetProductId: offer.targetProductId,
      targetVariantId: firstVariant.id
    });

    if (select) {
      select.addEventListener('change', function () {
        var selected = select.selectedOptions[0];
        var selectedPrice = Number(selected.dataset.price);
        card.querySelector('.pg-complete-set__price-original').textContent = money(selectedPrice, cart.currency);
        card.querySelector('.pg-complete-set__price-offer').textContent = money(offerPrice(selectedPrice), cart.currency);
        button.dataset.targetVariantId = selected.value;
      });
    }

    content.append(button);
    card.append(image, content);
    return card;
  }

  function buildSection(context, data, cart, surface) {
    var section = createElement('section', 'pg-complete-set pg-complete-set--' + surface);
    var header = createElement('div', 'pg-complete-set__header');
    var offers = createElement('div', 'pg-complete-set__offers');
    section.dataset.pgCompleteSet = '';

    header.append(
      createElement('span', 'pg-complete-set__eyebrow', 'Use the same artwork'),
      createElement('h3', 'pg-complete-set__heading', 'Complete the set'),
      createElement('p', 'pg-complete-set__intro', 'Save 30% on matching extras. No second photo upload needed.')
    );

    data.forEach(function (entry) {
      offers.append(buildCard(context, entry, cart, surface));
    });

    section.append(
      header,
      offers,
      createElement(
        'p',
        'pg-complete-set__discount-status',
        SETTINGS.discountActive ? '30% discount applied automatically in your cart.' : '30% launch discount is configured and will activate with this pilot.'
      )
    );
    return section;
  }

  function compactCartMobileRail(section) {
    if (!window.matchMedia || !window.matchMedia('(max-width: 767px)').matches) return;
    var intro = section.querySelector('.pg-complete-set__intro');
    if (intro) intro.textContent = 'Swipe to choose matching extras. 30% off with the same approved artwork.';
    section.classList.add('pg-complete-set--cart-mobile-rail');
  }

  function ensureMounts() {
    document.querySelectorAll('.cart_content form[data-cart-form="mini-cart"]').forEach(function (form) {
      if (form.querySelector('[data-pg-complete-set-mount="drawer"]')) return;
      var items = form.querySelector('.cart_items');
      if (!items) return;
      var mount = createElement('div', 'pg-complete-set-mount pg-complete-set-mount--drawer');
      mount.dataset.pgCompleteSetMount = 'drawer';
      items.after(mount);
    });

    var column = document.querySelector('#pg-cart .pg-cart__items-col');
    if (column && !column.querySelector('[data-pg-complete-set-mount="cart"]')) {
      var cartMount = createElement('div', 'pg-complete-set-mount pg-complete-set-mount--cart');
      cartMount.dataset.pgCompleteSetMount = 'cart';
      var trust = column.querySelector('.pg-cart__trust-trio');
      if (trust) column.insertBefore(cartMount, trust);
      else column.append(cartMount);
    }
  }

  function clearMounts() {
    document.querySelectorAll('[data-pg-complete-set-mount]').forEach(function (mount) {
      delete mount.dataset.pgCompleteSetSignature;
      mount.replaceChildren();
    });
  }

  function renderSignature(context, data) {
    return JSON.stringify({
      source: String(context.source.key || context.source.variant_id || ''),
      offers: data.map(function (entry) {
        return [
          entry.offer.type,
          String(entry.offer.targetProductId),
          entry.variants.map(function (variant) { return String(variant.id); })
        ];
      })
    });
  }

  async function refresh() {
    if (busy) return;
    busy = true;

    try {
      ensureMounts();
      var cart = await getCart();
      var context = getContext(cart);

      if (!context) {
        clearMounts();
        return;
      }

      // A single temporarily unavailable matching product must not hide all
      // remaining Complete the Set offers from either cart surface.
      var candidates = await Promise.all(context.offers.map(async function (offer) {
        try {
          var product = await getProduct(offer.targetHandle);
          return { offer: offer, product: product, variants: availableVariants(product, offer) };
        } catch (error) {
          console.warn('Paw & Glory matching offer unavailable:', offer.targetHandle, error && error.message || error);
          return null;
        }
      }));
      var data = candidates.filter(function (entry) {
        return entry && entry.variants.length > 0;
      });

      if (!data.length) {
        clearMounts();
        return;
      }

      var signature = renderSignature(context, data);
      document.querySelectorAll('[data-pg-complete-set-mount]').forEach(function (mount) {
        if (mount.dataset.pgCompleteSetSignature === signature && mount.firstElementChild) return;
        mount.dataset.pgCompleteSetSignature = signature;
        var section = buildSection(context, data, cart, mount.dataset.pgCompleteSetMount);
        if (mount.dataset.pgCompleteSetMount === 'cart') compactCartMobileRail(section);
        mount.replaceChildren(section);
      });
    } catch (error) {
      console.warn('Paw & Glory complete-the-set:', error.message);
      clearMounts();
    } finally {
      busy = false;
    }
  }

  function scheduleRefresh(delay) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(refresh, delay == null ? 180 : delay);
  }

  function findSource(cart, button) {
    return (cart.items || []).find(function (item) {
      return String(item.key) === String(button.dataset.sourceLine);
    }) || (cart.items || []).find(function (item) {
      return String(item.product_id) === String(button.dataset.sourceProductId) &&
        String(item.variant_id) === String(button.dataset.sourceVariantId);
    });
  }

  async function linkArtwork(source, button) {
    var existing = property(source, '_pg_artwork_group');
    if (existing) return { source: source, group: existing };

    var artworkGroup = newArtworkGroup();
    var properties = Object.assign({}, cleanProperties(source.properties), {
      _pg_artwork_group: artworkGroup,
      _pg_source_product: String(button.dataset.sourceProductId),
      _pg_source_variant: String(source.variant_id)
    });

    var changedCart = await requestJson(root() + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        id: String(source.key),
        quantity: Number(source.quantity),
        properties: properties
      })
    });

    var linkedSource = (changedCart.items || []).find(function (item) {
      return String(item.product_id) === String(button.dataset.sourceProductId) &&
        String(item.variant_id) === String(source.variant_id) &&
        property(item, '_pg_artwork_group') === artworkGroup;
    });

    if (!linkedSource) throw new Error('The portrait artwork link could not be confirmed.');
    return { source: linkedSource, group: artworkGroup };
  }

  function addExtra(linked, button) {
    return requestJson(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{
          id: Number(button.dataset.targetVariantId),
          quantity: 1,
          properties: {
            _pg_artwork_group: linked.group,
            _pg_upsell_source_line: String(linked.source.key || ''),
            _pg_source_product: String(button.dataset.sourceProductId),
            _pg_source_variant: String(linked.source.variant_id),
            _pg_upsell_target_product: String(button.dataset.targetProductId),
            _pg_upsell_type: String(button.dataset.offerType),
            'Use the same approved artwork': 'Yes'
          }
        }],
        sections: ['header'],
        sections_url: window.location.pathname
      })
    });
  }

  function replaceDrawer(html) {
    if (!html) return false;
    var documentFragment = new DOMParser().parseFromString(html, 'text/html');
    var fresh = documentFragment.querySelector('.cart_content form[data-cart-form="mini-cart"]');
    var current = document.querySelector('.cart_content form[data-cart-form="mini-cart"]');
    var cartContent = document.querySelector('.cart_content');
    if (!fresh || !current || !cartContent) return false;

    var scrollTop = cartContent.scrollTop;
    current.replaceWith(fresh);
    cartContent.scrollTop = scrollTop;

    var count = documentFragment.querySelector('.cart_count');
    if (count) {
      document.querySelectorAll('.cart_count').forEach(function (element) {
        element.textContent = count.textContent.trim();
      });
    }
    return true;
  }

  async function handleAdd(button) {
    if (button.disabled || busy) return;
    var originalLabel = button.textContent;
    button.disabled = true;
    button.textContent = 'Adding…';
    busy = true;

    try {
      var cart = await getCart();
      var source = findSource(cart, button);
      var config = source && CONFIG[String(source.product_id)];
      var offer = config && config.offers.find(function (candidate) {
        return candidate.type === button.dataset.offerType;
      });

      if (!source || !config || !offer || !eligible(source, config)) {
        throw new Error('This portrait is not eligible for that matching add-on.');
      }
      if (targetAlreadyInCart(cart, offer)) {
        throw new Error('That matching add-on is already in your cart.');
      }

      var linked = await linkArtwork(source, button);
      var result = await addExtra(linked, button);
      button.textContent = 'Added';

      var replaced = replaceDrawer(result.sections && result.sections.header);
      if (!replaced) {
        var sectionsUrl = new URL(window.location.href);
        sectionsUrl.searchParams.set('sections', 'header');
        var sections = await requestJson(sectionsUrl.pathname + sectionsUrl.search, { cache: 'no-store' });
        replaced = replaceDrawer(sections.header);
      }

      busy = false;
      if (button.dataset.surface === 'cart' || !replaced) window.location.reload();
      else scheduleRefresh(80);
    } catch (error) {
      busy = false;
      if (button.isConnected) {
        button.disabled = false;
        button.textContent = originalLabel;
      }
      var section = button.closest('.pg-complete-set');
      var status = section && section.querySelector('.pg-complete-set__discount-status');
      if (status) {
        status.setAttribute('role', 'alert');
        status.textContent = error.message || 'The matching add-on could not be added. Please try again.';
      }
      console.warn('Paw & Glory Complete the Set:', error && error.message || error);
    }
  }

  function nodeTouchesCart(node) {
    if (!(node instanceof Element)) return false;
    var selector = '.cart_content form[data-cart-form="mini-cart"], .cart_items, #pg-cart, #pg-cart .pg-cart__items-col';
    return node.matches(selector) || Boolean(node.querySelector(selector));
  }

  function cartStructureChanged(mutations) {
    var drawerForm = document.querySelector('.cart_content form[data-cart-form="mini-cart"]');
    var cartColumn = document.querySelector('#pg-cart .pg-cart__items-col');

    if (drawerForm && !drawerForm.querySelector('[data-pg-complete-set-mount="drawer"]')) return true;
    if (cartColumn && !cartColumn.querySelector('[data-pg-complete-set-mount="cart"]')) return true;

    return mutations.some(function (mutation) {
      if (mutation.target.closest && mutation.target.closest('[data-pg-complete-set-mount]')) return false;
      if (mutation.target.closest && mutation.target.closest('.cart_items, #pg-cart .pg-cart__items-col')) return true;
      return Array.from(mutation.addedNodes).concat(Array.from(mutation.removedNodes)).some(nodeTouchesCart);
    });
  }

  function init() {
    document.addEventListener('click', function (event) {
      var button = event.target.closest && event.target.closest('[data-pg-complete-set-add]');
      if (!button) return;
      event.preventDefault();
      event.stopPropagation();
      handleAdd(button);
    }, true);

    document.addEventListener('cart:refresh', function () {
      if (!busy) scheduleRefresh(120);
    });

    if (window.jQuery) {
      window.jQuery(document).on('cart.requestComplete', function () {
        if (!busy) scheduleRefresh(120);
      });
    }

    if (window.MutationObserver) {
      observer = new MutationObserver(function (mutations) {
        if (!busy && cartStructureChanged(mutations)) scheduleRefresh(120);
      });
      observer.observe(document.body, { childList: true, subtree: true });
    }

    scheduleRefresh(50);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();
